export interface OTPCheckDto
{
    getMsisdn(): string;
    getLanguage(): string;
    getClientTxnId(): string;
    getOtp(): string;
    getSecToc(): string;
    getType(): string;

    getRespCode(): string;
    getRespDesc(): string;
    getSrvType(): string;
    getUserId(): string;
    getUserIdEnc(): string;
    getUserName(): string;
}

export class OTPCheckDtoImpl implements OTPCheckDto
{
    private msisdn: string;
    private language: string;
    private clientTxnId: string;
    private otp: string;
    private secToc: string;
    private type: string;
    private respCode: string;
    private respDesc: string;
    private srvType: string;
    private userId: string;
    private userIdEnc: string;
    private userName: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getClientTxnId(): string 
    {
        return this.clientTxnId;
    }
    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }

    getOtp(): string 
    {
        return this.otp;
    }
    setOtp(otp: string)
    {
        this.otp = otp;
    }

    getSecToc(): string 
    {
        return this.secToc;
    }
    setSecToc(secToc: string)
    {
        this.secToc = secToc;
    }

    getType(): string 
    {
        return this.type;
    }
    setType(type: string)
    {
        this.type = type;
    }

    getRespCode(): string 
    {
        return this.respCode;
    }
    setRespCode(respCode: string)
    {
        this.respCode = respCode;
    }

    getRespDesc(): string 
    {
        return this.respDesc;
    }
    setRespDesc(respDesc: string)
    {
        this.respDesc = respDesc;
    }

    getSrvType(): string 
    {
        return this.srvType;
    }
    setSrvType(srvType: string)
    {
        this.srvType = srvType;
    }

    getUserId(): string 
    {
        return this.userId;
    }
    setUserId(userId: string)
    {
        this.userId = userId;
    }

    getUserIdEnc(): string 
    {
        return this.userIdEnc;
    }
    setUserIdEnc(userIdEnc: string)
    {
        this.userIdEnc = userIdEnc;
    }

    getUserName(): string 
    {
        return this.userName;
    }
    setUserName(userName: string)
    {
        this.userName = userName;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/otp/otpcheck/otpcheckdto.tsx